module.exports = __webpack_public_path__ + "static/media/id-card-regular.0c31c543.svg";